import React, { useEffect, useState } from 'react';
import InstructorCard from '../compnents/cards/userCard';
import { BASE_URL } from '../config/constants';
import Cookie from 'js-cookie';

const InstructorsPage = () => {
	const [instructors, setInstructors] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	// Media API function similar to LearningPaths component
	const getMediaInfo = async (mediaId) => {
		try {
			const response = await fetch(`${BASE_URL}/api/v1/media/${mediaId}/info`, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			if (!response.ok) {
				throw new Error('Failed to fetch media info');
			}

			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error fetching media info:', error);
			return null;
		}
	};

	// Helper function to validate URLs
	const isValidUrl = (url) => {
		if (!url) return false;
		if (typeof url !== 'string') return false;
		if (url.includes('undefined') || url.includes('null')) return false;
		if (url.trim() === '') return false;
		return true;
	};

	// Function to get image URL from instructor data
	const getImageUrl = async (instructor) => {
		if (!instructor.photo) return null;

		console.log('📸 Instructor photo object:', instructor.photo);

		// Try direct URL first
		if (instructor.photo.url && isValidUrl(instructor.photo.url)) {
			console.log('✅ Using direct photo URL:', instructor.photo.url);
			return instructor.photo.url;
		}

		// Try to construct URL from media ID
		if (instructor.photo.id) {
			// Try the download endpoint first (more direct)
			const downloadUrl = `${BASE_URL}/api/v1/media/${instructor.photo.id}`;
			console.log('🔍 Trying download URL:', downloadUrl);

			// You can also try to get media info for more details
			try {
				const mediaInfo = await getMediaInfo(instructor.photo.id);
				if (mediaInfo?.url && isValidUrl(mediaInfo.url)) {
					console.log('✅ Using media info URL:', mediaInfo.url);
					return mediaInfo.url;
				}
			} catch (error) {
				console.warn('Could not fetch media info, using download URL');
			}

			// Fallback to download endpoint
			return downloadUrl;
		}

		console.warn('⚠️ No valid photo data found for instructor');
		return null;
	};

	const fetchInstructors = async () => {
		try {
			setLoading(true);
			console.log(
				'📡 Fetching instructors from:',
				`${BASE_URL}/api/v1/teacher`
			);

			const response = await fetch(`${BASE_URL}/api/v1/teacher`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			console.log('📥 Response status:', response.status);

			if (response.ok) {
				const data = await response.json();
				console.log('✅ Instructors data received:', data);

				// Process instructors with their images
				const instructorsWithImages = await Promise.all(
					data.map(async (instructor) => {
						const imageUrl = await getImageUrl(instructor);
						return {
							...instructor,
							imageUrl: imageUrl,
						};
					})
				);

				setInstructors(instructorsWithImages);
			} else {
				throw new Error('Failed to fetch instructors');
			}
		} catch (error) {
			console.error('Error fetching instructors:', error);
			setError('Failed to load instructors');
		} finally {
			setLoading(false);
			console.log('⏳ Loading finished');
		}
	};

	useEffect(() => {
		console.log('🚀 InstructorsPage mounted, fetching instructors...');
		fetchInstructors();
	}, []);

	if (loading) {
		return (
			<div className='min-h-screen bg-transparent px-6 py-12 mt-28 flex justify-center items-center'>
				<div className='text-blue-500 text-xl'>جاري التحميل...</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className='min-h-screen bg-transparent px-6 py-12 mt-28 flex justify-center items-center'>
				<div className='text-red-500 text-xl'>{error}</div>
			</div>
		);
	}

	console.log('📊 Rendering instructors count:', instructors.length);

	return (
		<div className='min-h-screen bg-transparent px-6 py-12 mt-28'>
			<h2 className='text-center text-blue-500 text-3xl font-bold mb-10'>
				الخبراء
			</h2>

			{instructors.length === 0 ? (
				<div className='text-center text-gray-500 text-xl'>
					لا يوجد خبراء متاحين حالياً
				</div>
			) : (
				<div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8'>
					{instructors.map((instructor) => {
						console.log('👤 Rendering instructor:', instructor);
						return (
							<InstructorCard
								key={instructor.id}
								name={instructor.name}
								title={instructor.description || 'خبير'}
								image={instructor.imageUrl} // Use the processed imageUrl
							/>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default InstructorsPage;
